<template>
  <div class="mr-4 ml-4" style="width: 90vw;">
    <div class="row w-100 text-primary mb-4" style="font-size: 1rem;">
      <b class="mr-1">Instrucciones: </b> {{instructions}}
    </div>

    <div class="row w-100">
      <div class="col-md text-center">
        <button v-if="!isPlaying" class="btn btn-success w-50" @click="start()">
          <i class="fas fa-play-circle"></i>
          Comenzar
        </button>
        <button v-else class="btn btn-danger w-50" @click="stop()">
          <i class="fas fa-stop-circle"></i>
          Detener
        </button>
      </div>
      <div class="col-md text-center">
        <button class="btn btn-primary w-50" :disabled="!isPlaying || countDownValue > 0" @click="nextWord()">
          Siguiente
          <i class="fas fa-forward"></i>
        </button>
      </div>
    </div>

    <div class="row w-100">
      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div class="row text-center w-100" @click="nextWord()">
      <div class="card pb-4 text-primary">
        <div class="card-body" style="height: 5rem;">
          <div class="row" v-if="countDownValue > 0">
            <div class="col-lg text-center" v-if="isPlaying">
              ¡Prepárate!
              <br>
              <span style="font-size: 2.5rem;">{{countDownValue}}</span> 
            </div>
          </div>
          <div class="row" v-else-if="numberOfWords == 3">
            <div class="col-sm pt-3 text-right">
              <span style="font-size: 1.5rem;" v-if="allWords[currentWordsIndex - 1]">
                {{allWords[currentWordsIndex -1]}}
              </span> 
            </div>
            <div class="col-sm text-center">
              <span style="font-size: 2.5rem;" v-if="allWords[currentWordsIndex]">
                {{allWords[currentWordsIndex]}}
              </span> 
            </div>
            <div class="col-sm pt-3 text-left">
              <span style="font-size: 1.5rem;" v-if="allWords[currentWordsIndex + 1]">
                {{allWords[currentWordsIndex + 1]}}
              </span>
            </div>
          </div>
          <div class="row" v-else-if="numberOfWords == 2">
            <div class="col-md text-right">
              <span style="font-size: 2.5rem;" v-if="allWords[currentWordsIndex]">
                {{allWords[currentWordsIndex]}}
              </span>
            </div>
            <div class="col-md pt-3 text-left">
              <span style="font-size: 1.5rem;" v-if="allWords[currentWordsIndex + 1]">
                {{allWords[currentWordsIndex + 1]}}
              </span>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-lg text-center">
              <span style="font-size: 2.5rem;" v-if="allWords[currentWordsIndex]">
                {{allWords[currentWordsIndex]}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'manual-reading-per-words',
  interval: null,
  timeout: null,
  startInterval: null,
  timerInterval: null,
  props: {
    instructions: {
      type: String,
      default: 'Cuando estés listo da clic en "Comenzar" y realiza la lectura, da clic en el recuadro de texto o el botón de "Siguiente" para avanzar.'
    },
    text: {
      type: String,
      required: true
    },
    timer: {
      type: Number,
      validator: (value) => {
        if (value >= 1) return true;
        return false;
      }
    },
    numberOfWords: {
      type: Number,
      default: 1,
      validator: (value) => {
        if (value > 0 && value < 4) return true;
        return false;
      }
    }
  },
  data() {
    return {
      currentWordsIndex: 0,
      isPlaying: false,
      countDownValue: 3,
      timerValue: 0,
      duration: 0,
      successMessage: ''
    }
  },
  created () {
    this.timerValue = this.timer;
  },
  computed: {
    allWords() {
      return this.text.split(' ').filter(word => word && word !== '\n');
    },
    allWordsLength() {
      return this.allWords.length;
    },
  },
  methods: {
    start() {
      this.successMessage = '';
      this.countDownValue = 3;
      this.currentWordsIndex = 0;
      this.isPlaying = true;
      this.initCountDown();
      setTimeout(() => {
        this.setInterval();
        if (this.timer) this.countDownTimer();
      }, 3000);
    },
    stop() {
      if (this.countDownValue > 0) return;
      this.currentWordsIndex = 0;
      this.timerValue = this.timer;
      this.duration = 0;
      this.countDownValue = 3;
      this.isPlaying = false;
      clearInterval(this.interval);
      clearInterval(this.startInterval);
    },
    setInterval() {
      this.interval = setInterval(() => {
        this.duration = this.duration + 1;
      }, 1000);
    },
    nextWord() {
      if (this.currentWordsIndex + 1 == this.allWordsLength) {
        this.successMessage = `¡Has terminado!, leiste ${this.currentWordsIndex + 1} palabras en ${this.duration} segundos a una velocidad de ${parseInt((((this.currentWordsIndex + 1) * 60) / this.duration))} palabras por minuto`;
        this.stop();
      } else this.currentWordsIndex = this.currentWordsIndex + 1;
    },
    initCountDown(){
      this.startInterval = setInterval(() => {
        this.countDownValue = this.countDownValue - 1;
        if (this.countDownValue == 0) clearInterval(this.startInterval);
      }, 1000);
    },
    countDownTimer(){
      this.timerInterval = setInterval(() => {
        this.timerValue = this.timerValue - 1;
        if (this.timerValue == 0) {
          clearInterval(this.timerInterval);
          this.successMessage = `¡Se acabó el tiempo!, leiste ${this.currentWordsIndex + 1} palabras en ${this.duration} segundos a una velocidad de ${parseInt((((this.currentWordsIndex + 1) * 60) / this.duration))} palabras por minuto`;
          this.stop();
        }
      }, 1000);
    }
  }
}
</script>

<style scoped>
.btn-success {
  background-color: rgba(24, 206, 15, 0.8);
}
</style>
